<template>
<div class="people">
</div>
</template>

<script>
export default {
  name: 'people'
}
</script>

<style lang="scss">
@keyframes people-move {
  0% {
    bottom: fluid(138px);
    left: fluid(267px);
  }
  13% {
    bottom: fluid(150px);
    left: fluid(260px);
  }
  28% {
    bottom: fluid(163px);
    left: fluid(284px);
  }
  46% {
    bottom: fluid(177px);
    left: fluid(286px);
  }
  63% {
    height: fluid(85px);
    bottom: fluid(190px);
  }
  80% {
    bottom: fluid(210px);
    left: fluid(282px);
  }
  100% {
    bottom: fluid(235px);
    left: fluid(282px);
  }
}
.people {
  position: absolute;
  width: fluid(40px);
  height: fluid(85px);
  bottom: fluid(138px);
  left: fluid(267px);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  background-image: url('~@/assets/img/people.png');
}
.people-moving {
  .people {
    animation: people-move 12s linear infinite;
  }
}
.people-moved {
  .people {
    bottom: fluid(235px);
    left: fluid(282px);
  }
}
</style>